import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntegrateJira } from "../../Hooks/layout/useIntegrateJira";
import { Step, StepLabel, Stepper } from "@mui/material";
import { SkeletonContainer } from "../Loader/Loader";

const IntegrateJiraToken = ({ fromProfile }) => {

    const { inputValue, setinputValue, handlePaste, handleUserAccountToken, currStep, setCurrStep, changeProfileVisibility, handleSaveProfileVisibility, profileVisibilityStep, popupClosed, loader } = useIntegrateJira();

    return (
        <div className="p-1" style={{ minHeight: "20vh" }}>
            {loader?.val ? <div style={{ height: "20vh" }}><SkeletonContainer /></div> :
                <div className="d-flex gap-2 align-items-center">
                    {(currStep === 0 || currStep === 1) &&
                        <div className='w5 d-flex justify-content-center align-items-center' >
                            <Stepper orientation="vertical" activeStep={currStep}>
                                {Array.from({ length: 2 }, (_, index) => (
                                    <Step key={index} title={index === 0 ? "Change profile visibility" : "Integrate Jira Token"}>
                                        <StepLabel> </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </div>
                    }
                    {currStep === -1 ?
                        <div className="d-flex flex-column gap-2 justify-content-center align-items-center w100">
                            <FontAwesomeIcon icon="fa-solid fa-circle-exclamation" className="fs-1" />
                            <div className="fs-6 fw-bold text-center">
                                Please contact your reporting manager to create a JIRA account request!
                            </div>
                        </div> :
                        (
                            currStep === 0 ?
                                <div className="w95 position-relative rounded" style={{ height: "20vh", boxShadow: fromProfile ? "none" : "1px 1px 20px #dbdbdb", fontSize: "0.95rem" }}>
                                    <div className="d-flex align-items-center" style={{ height: "100%" }}>
                                        <ol>
                                            <li className="text-dark">
                                                <span className="text-primary c-pointer" onClick={() => changeProfileVisibility("visibility")}>Click here</span> to change your profile visibility.
                                            </li>
                                            <li style={{ color: profileVisibilityStep >= 2 ? 'black' : '#979797' }}>
                                                In the new window, scroll to the <strong>Contact</strong> section.
                                            </li>
                                            <li style={{ color: profileVisibilityStep >= 2 ? 'black' : '#979797' }}>
                                                Change the status from <strong>"You & Admin"</strong> to <strong>"Anyone"</strong>.
                                            </li>
                                            <li style={{ color: popupClosed ? 'black' : '#979797' }}>
                                                Click <strong>Apply</strong> below to save changes.
                                            </li>
                                        </ol>
                                    </div>
                                    <div className="text-right position-absolute" style={{ bottom: "5px", right: "5px" }}>
                                        {loader?.btn ?
                                            <button className="button btn-primary" style={{width: "55px"}}>
                                                <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                                    <span className="sr-only"></span> </div>
                                            </button> :
                                            <button className="button btn-primary" onClick={() => handleSaveProfileVisibility()}>Apply</button>
                                        }
                                    </div>
                                </div>
                                : (
                                    currStep === 1 ?
                                        <div className="w95 rounded d-flex flex-column justify-content-center align-items-center p-2" style={{ height: "20vh", boxShadow: fromProfile ? "none" : "1px 1px 20px #dbdbdb" }}>
                                            <div className='logo-container'>
                                                <div className='intigration-logo' style={{ marginLeft: "10px" }}>
                                                    <img src="./assets/jira.png" alt="srkay-logo" />
                                                </div>
                                                <div className='intigration-logo' style={{ marginLeft: "-10px" }}>
                                                    <img src="./assets/srkay-icon.png" alt="srkay-logo" />
                                                </div>
                                            </div>
                                            <div className='normal-text mt-1 mb-1'>
                                                <span className="text-primary c-pointer" onClick={() => changeProfileVisibility("token")}>Click here</span> to get token, <b>paste</b> below and <b>save</b> to integrate.
                                            </div>
                                            <div className="d-flex align-items-center gap-2 w100" style={{ position: 'relative' }}>
                                                <input placeholder="Paste here" className="intigration-input" type="text" value={inputValue} onChange={(e) => setinputValue(e.target.value)} />
                                                <div className='paste-icon c-pointer' onClick={(e) => handlePaste(e)}>
                                                    <FontAwesomeIcon icon="fa-solid fa-paste" />
                                                </div>
                                                <button className='button btn-primary w20' onClick={handleUserAccountToken}><FontAwesomeIcon icon="fa-solid fa-check" /> Save</button>
                                            </div>
                                        </div>
                                        : (currStep === 2 ?
                                            <div className="w100">
                                                <div className="d-flex flex-column gap-2 justify-content-center align-items-center w100">
                                                    <div className='logo-container'>
                                                        <div className='intigration-logo' style={{ marginLeft: "10px" }}>
                                                            <img src="./assets/jira.png" alt="srkay-logo" />
                                                        </div>
                                                        <div className='intigration-logo' style={{ marginLeft: "-10px" }}>
                                                            <img src="./assets/srkay-icon.png" alt="srkay-logo" />
                                                        </div>
                                                    </div>
                                                    <span className="fs-6 fw-bold text-center">Congratulations! You've successfully integrated JIRA with Insights.</span>
                                                </div>
                                                <div className="text-center text-primary mt-1 c-pointer" onClick={() => setCurrStep(1)}>Update Token?</div>
                                            </div>
                                            :
                                            <></>
                                        )
                                )
                        )
                    }
                </div>
            }
        </div>
    )
}

export default IntegrateJiraToken;